module.exports = __webpack_public_path__ + "static/media/download.7a95c83f.svg";